module.exports = __webpack_public_path__ + "static/img/myLover.a2f918e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/myLover.jpg
// module id = W4YL
// module chunks = 2